(() => {
  if (window.syncCartDrawer) return;

  let inFlight = null;
  let pendingOpen = false;
  let pendingDispatch = false;
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function openDrawerFallback() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const trigger = document.querySelector('[data-cart-trigger]');
    if (trigger && typeof trigger.click === 'function') {
      trigger.click();
      return;
    }

    window.location.href = routes.cart_url || '/cart';
  }

  function rebindOverlayClose() {
    const drawer = document.querySelector('cart-drawer');
    const overlay = drawer ? drawer.querySelector('#CartDrawer-Overlay') : null;
    if (!drawer || !overlay) return;
    overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  async function fetchSectionPair() {
    const stamp = Date.now();
    const drawerUrl = `${routes.cart_url}?section_id=cart-drawer&_=${stamp}`;
    const bubbleUrl = `${routes.cart_url}?section_id=cart-icon-bubble&_=${stamp}`;
    const [drawerHtml, bubbleHtml] = await Promise.all([
      fetch(drawerUrl, { headers: { Accept: 'text/html' }, cache: 'no-store' }).then((r) => r.text()),
      fetch(bubbleUrl, { headers: { Accept: 'text/html' }, cache: 'no-store' }).then((r) => r.text()),
    ]);
    return { drawerHtml, bubbleHtml };
  }

  async function refreshSections() {
    let payload = await fetchSectionPair();
    let drawerDoc = new DOMParser().parseFromString(payload.drawerHtml, 'text/html');
    let hasItems = Boolean(drawerDoc.querySelector('#CartDrawer .cart-item'));

    if (!hasItems) {
      try {
        const cartState = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        }).then((r) => r.json());
        if (cartState && cartState.item_count > 0) {
          await sleep(180);
          payload = await fetchSectionPair();
          drawerDoc = new DOMParser().parseFromString(payload.drawerHtml, 'text/html');
          hasItems = Boolean(drawerDoc.querySelector('#CartDrawer .cart-item'));
        }
      } catch (error) {
        console.warn('Cart state probe failed:', error);
      }
    }

    const drawerHtml = payload.drawerHtml;
    const bubbleHtml = payload.bubbleHtml;
    const drawerHost = document.querySelector('cart-drawer');
    if (drawerHost) drawerHost.classList.toggle('is-empty', !hasItems);

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        id: Date.now(),
        sections: {
          'cart-drawer': drawerHtml,
          'cart-icon-bubble': bubbleHtml,
        },
      });
      return true;
    }

    const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');

    const currentDrawer = document.getElementById('CartDrawer');
    const nextDrawer = drawerDoc.querySelector('#CartDrawer');
    if (currentDrawer && nextDrawer) currentDrawer.innerHTML = nextDrawer.innerHTML;

    const currentBubble = document.getElementById('cart-icon-bubble');
    const nextBubble =
      bubbleDoc.querySelector('#shopify-section-cart-icon-bubble #cart-icon-bubble') ||
      bubbleDoc.getElementById('cart-icon-bubble');
    if (currentBubble && nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;

    rebindOverlayClose();
    return false;
  }

  window.syncCartDrawer = function syncCartDrawer(options = {}) {
    const shouldOpen = options.open !== false;
    const shouldDispatch = options.dispatch !== false;
    const addResponse = options.addResponse;
    pendingOpen = pendingOpen || shouldOpen;
    pendingDispatch = pendingDispatch || shouldDispatch;

    if (shouldOpen) openDrawerFallback();

    const drawer = document.querySelector('cart-drawer');
    if (
      addResponse &&
      addResponse.sections &&
      typeof addResponse.sections['cart-drawer'] === 'string' &&
      addResponse.sections['cart-drawer'].length > 0 &&
      typeof addResponse.sections['cart-icon-bubble'] === 'string' &&
      addResponse.sections['cart-icon-bubble'].length > 0 &&
      drawer &&
      typeof drawer.renderContents === 'function'
    ) {
      drawer.classList.remove('is-empty');
      drawer.renderContents({
        id: addResponse.id || Date.now(),
        sections: addResponse.sections,
      });
      if (shouldDispatch) document.dispatchEvent(new CustomEvent('cart:updated'));
      pendingOpen = false;
      pendingDispatch = false;
      return Promise.resolve(addResponse);
    }

    if (inFlight) return inFlight;

    inFlight = refreshSections()
      .catch((error) => {
        console.error('Cart drawer sync failed:', error);
      })
      .finally(() => {
        if (pendingDispatch) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
        pendingOpen = false;
        pendingDispatch = false;
        inFlight = null;
      });

    return inFlight;
  };
})();
